import { LinearGradient } from 'expo-linear-gradient';
import withLink from 'hoc/withLink';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

const SectionHeaderComponent: React.FC<Partial<CmsHomeSection>> = ({ separator, title, more }) => {
  const TextWithLink = withLink(Text, 'section-link');

  return (
    <>
      {separator && (
        <LinearGradient
          colors={theme.gradient_colors.primary}
          start={{ x: 0.1, y: 0.1 }}
          end={{ x: 1, y: 0 }}
          locations={[0.1, 0.2, 0.5, 1]}
          style={styles.separator}
        />
      )}
      <View style={styles.container}>
        <Text style={styles.title}>{title}</Text>
        {!!more?.link && !Platform.isTV && (
          <View>
            <TextWithLink style={styles.moreLink} link={more.link}>
              {more.title || 'ver mais'}
            </TextWithLink>
          </View>
        )}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  separator: {
    height: calcSizeForDevice(1),
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: Platform.OS !== 'web' ? 10 : calcSizeForDevice(30, 40),
    paddingBottom: Platform.OS !== 'web' ? 10 : calcSizeForDevice(20, 40),
    paddingHorizontal: 0,
  },
  title: {
    color: 'white',
    fontSize: calcSizeForDevice(18, 28),
    fontWeight: 'bold',
  },
  moreLink: {
    color: '#839cff',
    fontWeight: 'bold',
    fontSize: calcSizeForDevice(14),
  },
});

export default SectionHeaderComponent;
